<template>
  <ResponsiveImage :image class="image" />
</template>

<script lang="ts" setup>
import { type MediaImageFragment } from '#graphql-operations'

export interface Props {
  image: MediaImageFragment
}

defineProps<Props>()
</script>

<style lang="scss" scoped>
@use "~/assets/sass/tools";

.image {
  @include tools.page-grid-columns;
  display: flex;
  flex-direction: column;
  gap: var(--space--sm);
}
</style>
